module.exports = __webpack_public_path__ + "static/media/confetti.e410fa11.svg";